import { RxapDataSource } from 'eurogard-data-source';
import { Injectable, inject } from '@angular/core';
import { PanelAccordionDataSource } from 'eurogard-data-source/accordion';
import {
  NotificationAccordionSettingsControllerGetByIdResponse
} from 'open-api-service-shared-features/responses/notification-accordion-settings-controller-get-by-id.response';
import {
  NotificationAccordionSettingsControllerGetByIdRemoteMethod
} from 'open-api-service-shared-features/remote-methods/notification-accordion-settings-controller-get-by-id.remote-method';

@Injectable()
@RxapDataSource('settings-panel')
export class AlarmingSettingsPanelDataSource extends PanelAccordionDataSource<NotificationAccordionSettingsControllerGetByIdResponse> {
  protected override readonly method = inject(NotificationAccordionSettingsControllerGetByIdRemoteMethod);
}
